import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/inset-block-end}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=inset-block-end.js.map